import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import { useNavigate } from 'react-router-dom';
import {
  AssignmentIndOutlined,
  AssignmentInd,
  AssignmentOutlined,
  DescriptionOutlined,
  PersonAdd,
  PersonSearchOutlined,
  PostAddOutlined,
  PortraitOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function HRHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const navigate = useNavigate();
  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="HUMAN RESOURCES" subtitle="Recruiting" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Brigad"
          onClick={() => {
                window.open('https://brigad.co');
              }}
          icon={
            <PersonSearchOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Interview Form"
          onClick={() => {
                window.open('https://forms.gle/s6j3aZ3yN3ns7ZiR6');
              }}
          icon={
            <PersonAdd
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Contract"
          onClick={() => {
                window.open('https://docs.google.com/document/d/10JGmt30k_b0oGPBrHp_MtacORAw0L1sUBvgDcPWf2uw/edit');
              }}
          icon={
            <DescriptionOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Job Script"
          onClick={() => {
                window.open('https://docs.google.com/document/d/1W9e1FgUsVEl8YSE_dqEMPTtzzj-qHjmzg5TaA1GiWNg/edit?usp=drive_link');
              }}
          icon={
            <AssignmentOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="CVs"
          onClick={() => {
                window.open('https://drive.google.com/drive/folders/1cN7sQgeR5IWwT8-y4mHbAYyplA-ry6UaaMtlD_dR6zloV95hK8tJFpGsgE3Xk8LHPTbyONK5?usp=drive_link');
              }}
          icon={
            <PortraitOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Registered Staff"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 2 */}
        <SceneBox
                  value="*Barman Cards"
          onClick={() => {
                window.open('');
              }}
          icon={
            <AssignmentInd
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
                  value="*Barback Serveur Cards"
          onClick={() => {
                window.open('');
              }}
          icon={
            <AssignmentIndOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />        
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Contract"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 3 */}
        <SceneBox
                  value="New contract"
          onClick={() => {
                navigate("/contractGen");
              }}
          icon={
            <PostAddOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};